export const TOTAL_STEPS = 4;

export const CREATE_SUCCESS = 'Le compte a été créé avec succès';

export const initialInfos = {
  firstname: '',
  lastname: '',
  dayOfBirth: '',
  gender: '',
  postal_code: '',
  town: '',
  phone: '',
  language: '' as number | '',
  diploma: '',
};
